// Build-time switches retain the original endpoints for a controlled rollback.
const useGen2Profiles = process.env.REACT_APP_GEN2_PROFILE_CALLABLES !== 'false';

export const PROFILE_FUNCTIONS = {
  claim: useGen2Profiles ? 'submitClaimProfileRequestV2' : 'submitClaimProfileRequest',
  unclaim: useGen2Profiles ? 'submitUnclaimProfileRequestV2' : 'submitUnclaimProfileRequest',
  updateEventStatus: useGen2Profiles ? 'triggerEventStatusUpdateV2' : 'triggerEventStatusUpdate',
};

export const UNSUBSCRIBE_FUNCTION = process.env.REACT_APP_GEN2_UNSUBSCRIBE === 'false'
  ? 'unsubscribe'
  : 'unsubscribeV2';

const useGen2Cancellation = process.env.REACT_APP_GEN2_CANCELLATION_CALLABLES !== 'false';
export const CANCELLATION_FUNCTIONS = {
  cancel: useGen2Cancellation ? 'cancelRegistrationByUserV2' : 'cancelRegistrationByUser',
  reverse: useGen2Cancellation ? 'reverseRegistrationCancellationV2' : 'reverseRegistrationCancellation',
};

// Keep payment routing scoped to the projects with a verified Gen2 deployment.
const useGen2Payments = process.env.REACT_APP_GEN2_PAYMENTS !== 'false'
  && ['runnershubtest', 'runnershub-62442'].includes(process.env.REACT_APP_FIREBASE_PROJECT_ID || '');
export const PAYMENT_FUNCTIONS = {
  checkout: useGen2Payments ? 'createStripeCheckoutSessionV2' : 'createStripeCheckoutSession',
  cancelConfirmation: useGen2Payments ? 'queueRegistrationConfirmationEmailV2' : 'queueRegistrationConfirmationEmail',
};

const useGen2Refunds = process.env.REACT_APP_GEN2_REFUNDS !== 'false'
  && ['runnershubtest', 'runnershub-62442'].includes(process.env.REACT_APP_FIREBASE_PROJECT_ID || '');
export const REFUND_FUNCTIONS = {
  process: useGen2Refunds ? 'processStripeRefundV2' : 'processStripeRefund',
  deposit: useGen2Refunds ? 'depositRefundsV2' : 'depositRefunds',
};

const useGen2AdminActions = process.env.REACT_APP_GEN2_ADMIN_ACTIONS !== 'false'
  && ['runnershubtest', 'runnershub-62442'].includes(process.env.REACT_APP_FIREBASE_PROJECT_ID || '');
export const ADMIN_FUNCTIONS = {
  actionRequest: useGen2AdminActions ? 'processActionRequestV2' : 'processActionRequest',
  autoLink: useGen2AdminActions ? 'processAutoLinkTaskV2' : 'processAutoLinkTask',
  claim: useGen2AdminActions ? 'processClaimTaskV2' : 'processClaimTask',
  volunteer: useGen2AdminActions ? 'manageMoVolunteerParticipationV2' : 'manageMoVolunteerParticipation',
};

const useAccountBindingReview = ['runnershubtest', 'runnershub-62442'].includes(
  process.env.REACT_APP_FIREBASE_PROJECT_ID || ''
) && process.env.REACT_APP_PERSON_IDENTITY_POLICY === 'strict-v1'
  && process.env.REACT_APP_ACCOUNT_BINDING_REVIEW === 'true';
export const ACCOUNT_BINDING_REVIEW_FUNCTION = useAccountBindingReview
  ? 'reviewAccountBindingWorkflowV2'
  : null;
export const REVIEWED_UNCLAIM_FUNCTION = ['runnershubtest', 'runnershub-62442'].includes(
  process.env.REACT_APP_FIREBASE_PROJECT_ID || ''
) && process.env.REACT_APP_PERSON_IDENTITY_POLICY === 'strict-v1'
  && process.env.REACT_APP_REVIEWED_UNCLAIM === 'true' ? 'reviewedUnclaimWorkflowV2' : null;

const useGen2Utilities = process.env.REACT_APP_GEN2_UTILITIES !== 'false'
  && ['runnershubtest', 'runnershub-62442'].includes(process.env.REACT_APP_FIREBASE_PROJECT_ID || '');
export const UTILITY_FUNCTIONS = {
  generateTestRegistrations: useGen2Utilities ? 'generateTestRegistrationsV2' : 'generateTestRegistrations',
};
